export default "__VITE_ASSET__C9o2UDVZ__"